package de.katoonerie.content

import androidx.compose.runtime.Composable
import de.katoonerie.components.Container
import de.katoonerie.components.Gradient
import de.katoonerie.contentful.Page

@Composable
fun Page.ActionsPage() {
    Gradient {
        Container {
            Tiles()
        }
    }
}
